<template>
    <BasePanel
        headline='lang_PUBLISHING_RELEASES_PANEL_CAPTION_SHEETS'
    >
        <template v-slot:panelContent>
            <v-container fluid>
                <v-row>
                    <v-col>
                        <v-data-table         
                            :headers="sheetsHeaders"
                            hide-default-footer
                            :items="sheets"                    
                            :expanded="expandedItems"
                            show-expand
                            sort-by="sheetNumber"
                            @click:row="expandItemByClick($event)"
                            :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                            :items-per-page="itemsPerPage"
                            class="noMinWidth"
                            :header-props="{ sortIcon: '' }"
                        >
                         <!-- TOP SLOT -->
                            <template v-slot:top>
                                <v-row class="pb-3">
                                    <v-spacer></v-spacer>
                                    <v-col cols="3">
                                        <BaseButton 
                                            @click="addNewRow"
                                            :disabled="$route.params.alvId === 'new'"
                                            label="lang_GENERAL_BUTTON_ADD_ROW"
                                            block
                                            :alvqa="alvqa + '-button-add-row'"
                                        />
                                    </v-col>
                                </v-row>
                            </template>
                        <!-- Sheet Headers -->
                            <template v-for="(header, i) in sheetsHeaders" v-slot:[`header.${header.value}`]>
                                <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                            </template>
                        <!-- Sheet Items -->
                            <!-- Expand Icon -->
                            <template v-slot:[`item.data-table-expand`]="{ isExpanded }">
                                <v-icon 
                                    v-if="isExpanded"
                                    small 
                                    class="ma-0 pa-0"
                                    color="buttonStandard"
                                >fa-arrow-alt-circle-down</v-icon>
                                <v-icon 
                                    v-else
                                    small 
                                    class="ma-0 pa-0"
                                    color="buttonStandard"
                                >fa-arrow-alt-circle-right</v-icon>
                            </template>
                        <!-- TITLE -->
                            <template v-slot:[`item.title`]="{ item }">
                                <BaseTooltip>
                                    <template v-slot:content>
                                        <div 
                                            :alvqa="alvqa + '-' + item.id + '-text-title'"
                                            class="ellipsis"
                                        >{{ item.title }}</div>
                                    </template>
                                    <template v-slot:text>{{ item.title }}</template>
                                </BaseTooltip>
                            </template>
                        <!-- COMPOSERS -->
                            <template v-slot:[`item.composers`]="{ item }">
                                <BaseTooltip>
                                    <template v-slot:content>
                                        <div 
                                            class="ellipsis"
                                            :alvqa="alvqa + '-' + item.id + '-text-composers'"
                                        >{{ item.composers.join(" / ") }}</div>
                                    </template>
                                    <template v-slot:text>{{ item.composers.join(" / ") }}</template>
                                </BaseTooltip>
                            </template>
                        <!-- PUBLISHERS -->
                            <template v-slot:[`item.publishers`]="{ item }">
                                <BaseTooltip>
                                    <template v-slot:content>
                                        <div 
                                            class="ellipsis"
                                            :alvqa="alvqa + '-' + item.id + '-text-publishers'"
                                        >{{ item.publishers.join(" / ") }}</div>
                                    </template>
                                    <template v-slot:text>{{ item.publishers.join(" / ") }}</template>
                                </BaseTooltip>
                            </template>
                        <!-- PRODUCTION YEAR -->
                            <template v-slot:[`item.productionYear`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.id + '-text-production-year'">
                                    {{ item.productionYear}}
                                </div>
                            </template>
                        <!-- SHEET NUMBER -->
                            <template v-slot:[`item.sheetNumber`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.id + '-text-sheet-number'">
                                    {{ item.sheetNumber }}
                                </div>
                            </template>
                        <!-- Delete Icon-->
                        <template v-slot:[`item.delete`]="{ item }">
                            <BaseIcon 
                                @click="deleteRow(item)"
                                icon="delete"
                                color="iconDelete"
                                tooltipText="lang_GENERIC_CAPTION_DELETE"
                                :alvqa="alvqa + 'list-row-icon-delete'"
                            />
                        </template>

                        <!-- EXPAND ITEM -->
                            <template v-slot:expanded-item="{ item }">
                                <td
                                    colspan="1"
                                    style="background-color: var(--v-expandPanelBackground-base);"
                                ></td>
                                <td 
                                    class="pl-0"
                                    :colspan="sheetsHeaders.length - 1"
                                    style="background-color: var(--v-expandPanelBackground-base);"
                                >                            
                                    <v-container fluid class="pl-0 pr-0">
                                        <v-row>
                                            <v-col class="pr-0">
                                                <v-data-table         
                                                    :headers="worksHeaders"
                                                    hide-default-footer
                                                    :items="item.works"
                                                    item-key="index"
                                                    :header-props="{ sortIcon: '' }"
                                                    :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                                                    :items-per-page="itemsPerPage"
                                                    class="noMinWidth"
                                                >
                                                <!-- Works Headers -->
                                                    <template v-for="(header, i) in worksHeaders" v-slot:[`header.${header.value}`]>
                                                        <span :alvqa="header.alvqa + '-' + item.sheetNumber" :key="i">{{ header.text }}</span>
                                                    </template>

                                                <!-- Work Items -->
                                                    <!-- Title -->
                                                    <template v-slot:[`item.title`]="{ item }">
                                                        <BaseTooltip>
                                                            <template v-slot:content>
                                                                <div 
                                                                    class='ellipsis'
                                                                    :alvqa="alvqa + '-works-list-row-' + item.id + '-text-title'"
                                                                >{{ item.title }}</div></template>                            
                                                            <template v-slot:text>{{ item.title }}</template>
                                                        </BaseTooltip>
                                                    </template>
                                                    <!-- Composers -->
                                                    <template v-slot:[`item.composers`]="{ item }">
                                                        <BaseTooltip>
                                                            <template v-slot:content>
                                                                <div 
                                                                    class="ellipsis"
                                                                    :alvqa="alvqa + '-works-list-row-' + item.id + '-text-composers'"
                                                                >{{ item.composers.join(" / ") }}</div>
                                                            </template>
                                                            <template v-slot:text>{{ item.composers.join(" / ") }}</template>
                                                        </BaseTooltip>
                                                    </template>
                                                    <template v-slot:[`item.publishers`]="{ item }">
                                                        <BaseTooltip>
                                                            <template v-slot:content>
                                                                <div 
                                                                    class="ellipsis"
                                                                    :alvqa="alvqa + '-works-list-row-' + item.id + '-text-publishers'"
                                                                >{{ item.publishers.join(" / ") }}</div>
                                                            </template>
                                                            <template v-slot:text>{{ item.publishers.join(" / ") }}</template>
                                                        </BaseTooltip>
                                                    </template>
                                                    <template v-slot:[`item.gemaNumber`]="{ item }">
                                                        <div :alvqa="alvqa + '-works-list-row-' + item.id + '-text-gema-number'">
                                                            {{ item.gemaNumber }}
                                                        </div>
                                                    </template>
                                                    <template v-slot:[`item.workSheetSeconds`]="{ item }">
                                                        <div :alvqa="alvqa + '-works-list-row-' + item.id + '-text-duration'">
                                                            {{ item.workSheetSeconds !== null ? $alvPlugin.transformSecondsToDuration(item.workSheetSeconds) + ' (' + (item.workSheetSeconds) + ')' : '' }}
                                                        </div>
                                                    </template>
                                                    <template v-slot:[`item.status`]="{ item }">
                                                        <div 
                                                            :alvqa="alvqa + '-works-list-row-' + item.id + '-text-status'"
                                                            class="text-right"
                                                        >
                                                            {{ $t(getStatus(item.status)) }}
                                                        </div>
                                                    </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-container>                            
                                </td>
                            </template>
                        </v-data-table>
                    </v-col>                    
                </v-row>
            </v-container>                         
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseIcon from '@/components/_buttons/BaseIcon'

import { DropdownPublishingWorksStatus } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "SheetsPanel",
    components: {
        BasePanel,
        BaseButton,
        BaseTooltip,
        BaseIcon
    },
    data() {
        return {
            expandedItems: [],
            alvqa: "publishing-projects-edit-form-panel-sheets"
        }
    },    
    watch: {
        sheets() {
            this.expandedItems = [];
        },
    },
    computed: {
        sheets() { 
            return this.$store.getters.getProjectsSheets
        },
        sheetsHeaders() {
            return [
                {
					text: '', 
					value: 'data-table-expand',
					align: 'center', 
					width: "48px"
				},
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_TITLE') + ' (' + this.sheets.length + ')', 
                    value: 'title', 
                    align: 'left', 
                    sortable: false, 
                    width: '250px',
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-title'
                },
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_COMPOSERS'), 
                    value: 'composers', 
                    align: 'left', 
                    sortable: false,
                    width: '180px',
                    alvqa: this.alvqa + '-header-composers'
                }, 
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_PUBLISHERS'), 
                    value: 'publishers', 
                    align: 'left', 
                    sortable: false,
                    alvqa: this.alvqa + '-header-publishers'
                },
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_PRODUCTION_YEAR'), 
                    value: 'productionYear',
                    align: 'right', 
                    sortable: false,
                    width: "150px",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-production-year'
                },
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_SHEET_NUMBER'), 
                    value: 'sheetNumber', 
                    align: 'right', 
                    sortable: false,
                    width: "150px",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-sheet-number'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    class: 'text-no-wrap'
                }
            ]
        },
        worksHeaders() {
            return [
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_WORK_TITLE'), 
                    value: 'title', 
                    align: 'left', 
                    sortable: false,
                    width: '250px',
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-title'
                },
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_COMPOSERS'), 
                    value: 'composers', 
                    align: 'left', 
                    sortable: false, 
                    width: '180px',
                    alvqa: this.alvqa + '-header-composers'
                }, 
                {
                    text: this.$t('lang_PUBLISHING_CAPTION_PUBLISHERS'), 
                    value: 'publishers', 
                    align: 'left', 
                    sortable: false,
                    alvqa: this.alvqa + '-header-publishers'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_WORK_ID'), 
                    value: 'gemaNumber', 
                    align: 'left', 
                    sortable: false, 
                    width: "140px",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-gema-number'
                },
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_SECONDS'), 
                    value: 'workSheetSeconds',
                    align: 'left', 
                    sortable: false,
                    width: "120px",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-duration'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_STATUS'), 
                    value: 'status', 
                    align: 'right', 
                    sortable: false, 
                    width: "200px",
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-status'
                }
            ]            
        },

        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {
        // Expand behaviour when clicking on a row. 
        async expandItemByClick(item) {            
            if(this.expandedItems.includes(item)) { // close item.
                let indexOfItem = this.expandedItems.indexOf(item)
                this.expandedItems.splice(indexOfItem, 1) 
            } else { // open item             
                this.expandedItems.push(item) 
            }                    
        },
        getStatus(dbValue) {
            return DropdownPublishingWorksStatus.find(status => {
                return status.value === dbValue
            }).text
        },
        addNewRow(){
            this.$store.commit('setShowSearchDialog', true)
        },
        deleteRow(item){
        // set the selected work/row that should be deleted from the delete action
            this.$store.commit('setSelectedProjectsSheet', [item])
            this.$store.commit('setDeletionDialogContext', 'SelectedProjectsSheet')
            this.$store.commit('setShowDeletionDialog', true)
        }
             
    }    
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>